import * as types from './constants.jsx';

export function getRefundRequests(arr) {
    return {
        type: types.GET_REFUND_REQUESTS,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/refund_requests/${arr.length && arr.length !== 0 ? '?' : ''}${arr.join('&')}`,
                method: "get"
            }
        }
    };
}

export function getSpecificRefundRequest(id) {
    return {
        type: types.GET_SPECIFIC_REFUND_REQUEST,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/refund_requests/${id}`,
                method: "get"
            }
        }
    };
}

export function postCreateRequest(data) {
    return {
        type: types.POST_REFUND_REQUEST,
        payload: {
            client: "default",
            request: {
                url: `/admin/japarts/refund_requests/`,
                method: "post",
                data,
            },
        },
    };
}

export function postCreateJoinRequest(data) {
    return {
        type: types.POST_CREATE_JOIN_REQUEST,
        payload: {
            client: "default",
            request: {
                url: `/admin/japarts/refund_requests/union/`,
                method: "post",
                data: {
                    refund_requests: data
                }
            },
        },
    };
}

export function splitRefundRequest(id, data) {
    return {
        type: types.SPLIT_REFUND_REQUEST,
        payload: {
            client: "default",
            request: {
                url: `/admin/japarts/refund_requests/${id}/split/`,
                method: "post",
                data: {
                    splitting_refund_requests: data
                }
            },
        },
    };
}

export function patchRefundRequestStatus(id, data) {
    return {
        type: types.PATCH_REFUND_REQUEST_STATUS,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/refund_requests/${id}`,
                method: "patch",
                data
            }
        }
    };
}

export function postRefundRequestConfirmStatus(id, data) {
    return {
        type: types.POST_REFUND_REQUEST_CONFIRM_STATUS,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/refund_requests/${id}/confirm/`,
                method: "post",
                data
            }
        }
    };
}

export function postDialogMessage(data) {
    return {
        type: types.POST_DIALOG_MESSAGE,
        payload: {
            client: "default",
            request: {
                url: `/refund/message/`,
                method: "post",
                data,
            },
        },
    };
}

export function postRefundRequestOffers(id, data) {
    return {
        type: types.POST_REFUND_REQUESTS_OFFERS,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/refund_requests/${id}/offers/`,
                method: "post",
                data
            }
        }
    };
}

// Номера УПД
export function getUPDNumbers(id) {
    return {
        type: types.GET_UPD_NUMBERS,
        payload: {
            client: "default",
            request: {
                url: `/admin/japarts/refund_requests/${id}/upd_numbers/`,
                method: "get",
            },
        },
    };
}

// Номера выдачи
export function getDocumentNumbers(id) {
    return {
        type: types.GET_DOCUMENT_NUMBERS,
        payload: {
            client: "default",
            request: {
                url: `/admin/japarts/refund_requests/${id}/document_numbers/`,
                method: "get",
            },
        },
    };
}

export function searchResiduesByDocumentNumber(document_number, article_number ) {
    return {
        type: types.SEARCH_RESIDUES_BY_DOCUMENT_NUMBER,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/residues_orders_search/`,
                params: {document_number, article_number},
                method: 'get'
            }
        }
    };
}

export function searchResiduesByUpdNumber(upd_number, article_number ) {
    return {
        type: types.SEARCH_RESIDUES_BY_DOCUMENT_NUMBER,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/accepted_orders_search/`,
                params: {upd_number, article_number},
                method: 'get'
            }
        }
    };
}
